export default "__VITE_ASSET__DbLbH7VC__"